export const mapMetaPixel = new Map<string, string>();
mapMetaPixel.set("localhost:4200","000000000000000"); 
mapMetaPixel.set("idemo.red-i.com.ar","000000000000000");
mapMetaPixel.set("asocespaniola.com.ar","000000000000000");
mapMetaPixel.set("amesalud.ar","000000000000000");
mapMetaPixel.set("centromedicomartinez.com.ar","000000000000000");
mapMetaPixel.set("espaciomo.ar","796454758887432");
mapMetaPixel.set("idev.red-i.kozaca.com.ar","000000000000000");
mapMetaPixel.set("romamedicinaestetica.com.ar","000000000000000");
mapMetaPixel.set("www.romamedicinaestetica.com.ar","000000000000000");